import useSWR from 'swr'
import { API } from '../api'

export type ConnectPreferencesPayload = {
  connectTitle: string
  connectLogoName: string
  connectLogoData: string
  connectMainLink: string
  connectHelpLink: string
  connectError: string
  connectDescription: string
  primaryColor: string
  connectMainLinkText: string
  connectHelpLinkText: string
  base64Favicon: string
  tabTitle: string
  jwtStrict: boolean
  magicLinkWidgetVersion?: 'v2' | 'v3'
  connectLayout?: 'default' | 'compact'
}

export type PreferencesResponse = {
  connectPrefs: ConnectPreferencesPayload
  uiPreferences: {
    primaryColor: string
    jwtStrict: boolean
  }
}

const usePreferences = (envId: string, apiKey: string) => {
  // Always call the useSWR hook, but conditionally pass null to prevent the request
  const { data, error, isLoading } = useSWR<PreferencesResponse, string>(
    // Only make the request if envId and apiKey are provided
    envId && apiKey ? [`/${envId}/preferences`, apiKey, API.CLIENT] : null
  )

  // Default empty object for connectPrefs
  const connectPrefs: ConnectPreferencesPayload = !data
    ? ({} as ConnectPreferencesPayload)
    : {
        ...data?.connectPrefs,
        primaryColor: data?.uiPreferences?.primaryColor ?? '#fa5442',
        jwtStrict: data?.uiPreferences?.jwtStrict ?? false,
      }

  const magicLinkWidgetVersion = data?.connectPrefs?.magicLinkWidgetVersion ?? 'v3'

  return {
    data: connectPrefs,
    magicLinkWidgetVersion,
    error,
    isLoading: isLoading || !envId || !apiKey,
  }
}

export default usePreferences
